import { StoreTaxDetails } from 'components/Cart/Details/components/OrderSummary/feature/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { storesApiService } from 'api/stores.api.service';

export const getShipmentStoreTaxHistory = createAsyncThunk(
  'shipment-store-tax-history/get',
  (filter: StoreTaxDetails) =>
    storesApiService.getShipmentStoreTaxHistory(filter),
);
